import { Box, Button, Input, Text, useToast } from "@chakra-ui/react";
import { useState } from "react";
import { useMutation } from "react-query";
import { comicFixLink } from "../../../services/readingOrdersApi";

// Mirrors the mobile NewLinkForm: admins paste a fresh MU/DCUI share link to
// replace the stored reading URL for an issue.
const NewLinkForm = ({ comicId }) => {
  const [value, setValue] = useState("");
  const toast = useToast({ duration: 5000, isClosable: true });
  const mutation = useMutation(({ url }) => comicFixLink(comicId, url), {
    onSuccess: () => {
      toast({
        title: "Link updated",
        description: "The comic URL has been updated.",
        status: "success",
      });
      setValue("");
    },
    onError: () => {
      toast({
        title: "An error occured",
        description: "Please contact our support at contact@theredwing.app",
        status: "error",
      });
      setValue("");
    },
  });

  return (
    <Box>
      <Text>
        To submit a new link, find the issue on MU or DCUI, tap the "Share" icon
        and paste the link below.
      </Text>
      <Box py="6px">
        <Input
          value={value}
          onChange={(event) => setValue(event.target.value)}
          placeholder="E.g: https://dcuniverseinfinite.com/comics/books/-/... OR https://www.marvel.com/comics/issue/..."
        />
      </Box>
      <Button
        colorScheme="red"
        color="white"
        isDisabled={mutation.isLoading}
        onClick={() => mutation.mutate({ url: value })}
      >
        Submit
      </Button>
    </Box>
  );
};

export default NewLinkForm;
